const STOP_WORDS = new Set([
    "a",
    "an",
    "and",
    "are",
    "as",
    "at",
    "be",
    "by",
    "for",
    "from",
    "in",
    "into",
    "is",
    "it",
    "of",
    "on",
    "or",
    "that",
    "the",
    "this",
    "to",
    "with",
    "you",
    "your",
]);
function normalize(value) {
    return value.toLowerCase();
}
function tokenize(query) {
    const tokens = query
        .split(/[^a-zA-Z0-9_$]+/g)
        .map((token) => token.trim().toLowerCase())
        .filter(Boolean)
        .filter((token) => token.length >= 2)
        .filter((token) => !STOP_WORDS.has(token));
    // De-dupe while keeping order.
    const seen = new Set();
    const unique = [];
    for (const token of tokens) {
        if (!seen.has(token)) {
            seen.add(token);
            unique.push(token);
        }
    }
    return unique;
}
function scoreSection(section, rawQuery, tokens) {
    const query = normalize(rawQuery);
    const id = normalize(section.id);
    const title = normalize(section.title);
    const tags = normalize(section.tags.join(" "));
    const content = normalize(section.content);
    let score = 0;
    if (query && title.includes(query))
        score += 20;
    if (query && id.includes(query))
        score += 18;
    if (query && tags.includes(query))
        score += 14;
    if (query && content.includes(query))
        score += 6;
    for (const token of tokens) {
        if (id.includes(token))
            score += 12;
        if (title.includes(token))
            score += 10;
        if (tags.includes(token))
            score += 7;
        if (content.includes(token))
            score += 2;
    }
    return score;
}
function buildSnippet(section, rawQuery, tokens) {
    const content = section.content || "";
    const normalizedContent = normalize(content);
    const normalizedQuery = normalize(rawQuery);
    const needle = normalizedQuery || tokens[0] || "";
    if (!needle) {
        return content.length > 180 ? `${content.slice(0, 180)}...` : content;
    }
    const idx = normalizedContent.indexOf(needle);
    if (idx < 0) {
        return content.length > 180 ? `${content.slice(0, 180)}...` : content;
    }
    const start = Math.max(0, idx - 80);
    const end = Math.min(content.length, idx + needle.length + 80);
    const prefix = start > 0 ? "..." : "";
    const suffix = end < content.length ? "..." : "";
    return `${prefix}${content.slice(start, end)}${suffix}`;
}
export function searchExcelPromptSections(params) {
    const query = params.query?.trim() || "";
    if (!query)
        return [];
    const requiredTags = (params.tags || []).map((tag) => tag.trim()).filter(Boolean);
    const limit = typeof params.limit === "number" && params.limit > 0 ? Math.min(20, params.limit) : 8;
    const tokens = tokenize(query);
    const hits = [];
    for (const section of params.sections) {
        if (requiredTags.length > 0) {
            const sectionTags = new Set(section.tags.map((tag) => tag.toLowerCase()));
            const ok = requiredTags.every((tag) => sectionTags.has(tag.toLowerCase()));
            if (!ok)
                continue;
        }
        const score = scoreSection(section, query, tokens);
        if (score <= 0)
            continue;
        hits.push({
            id: section.id,
            title: section.title,
            tags: section.tags,
            score,
            snippet: buildSnippet(section, query, tokens),
        });
    }
    hits.sort((a, b) => b.score - a.score);
    return hits.slice(0, limit);
}
